import type { Lang } from "./types";

type Dict = Record<string, string>;

const RU: Dict = {
  // Tabs
  tab_stats: "Статистика",
  tab_rating: "Рейтинг",
  tab_progress: "Прогресс",
  tab_bonus: "Бонус",
  // Period selector
  period_month: "Месяц",
  period_quarter: "Квартал",
  period_half: "Полугодие",
  period_year: "Год",
  coverage_all: "Учтены все {expected} мес. периода",
  coverage_partial: "Учтены {actual} из {expected} мес. — данных за остальные пока нет",
  prelim_badge: "предварительно",
  prelim_updated: "предварительно · обновлено {at}",
  prelim_period: "предварительно: {months} · обновлено {at}",
  // Header
  header_dept: "Отдел",
  header_maintenance_on: "Профилактика включена",
  header_maintenance_tap: "тап, чтобы выключить",
  // Stats
  kpi_label: "Итоговый KPI за период",
  kpi_status_over: "Перевыполнение",
  kpi_status_norm: "В норме",
  kpi_status_under: "Недобор",
  kpi_status_avg_suffix: " · в среднем за месяц периода",
  card_pure_sales: "Чистые продажи (личные)",
  card_returns: "Возвраты",
  card_remarks: "Замечания",
  card_reprimands: "Выговоры",
  card_competence: "Компетенции",
  card_dept: "Чистые продажи отдела",
  card_dept_note: "Считается на всю команду, в индивидуальный рейтинг не входит",
  plan_label: "план {value}",
  norm_label: "норма ≤ {value}%",
  kpi_value: "KPI: {value}%",
  kpi_value_avg: "KPI: {value}% (среднее)",
  total_sales_note: "Всего продаж: {value} грн (с учётом возвратов)",
  delivery_note: "в т. ч. вычтена доставка, оплаченная клиентками: {value} грн",
  returns_amount_note: "Сумма возвратов: {value} грн",
  competence_score_note: "Базовое начисление",
  // Rating
  rating_sales: "💰 Чистые продажи",
  rating_sales_sub: "· в среднем за день",
  rating_returns: "↩ Возвраты",
  rating_returns_sub: "· % от продаж, чем меньше — тем выше рейтинг",
  rating_sales_full: "В среднем за рабочий день · больше — лучше",
  rating_returns_full: "% от продаж · чем меньше — тем выше рейтинг",
  rating_you: "Вы",
  rating_place_of: "место",
  rating_of: "из",
  rating_grn_per_day: "грн/день",
  rating_pct_of_sales: "% от продаж",
  rating_how: "ⓘ Как считается рейтинг",
  rating_how_sales: "Продажи сравниваются по среднедневному показателю — учитывается, сколько дней вы отработали.",
  rating_how_returns: "Возвраты сравниваются в % от ваших продаж: кто меньше работал, тот меньше продал и в абсолюте возвратил меньше — поэтому справедливо именно процентное сравнение.",
  rating_how_anon: "Имена и цифры коллег не раскрываются.",
  // Progress
  progress_title: "Мой прогресс",
  progress_sub: "Чистые продажи по месяцам",
  progress_compare_to: "к {month}",
  progress_no_compare: "нет данных за предыдущий период",
  progress_plan_sales: "План продаж",
  progress_returns: "Возвраты",
  progress_from_plan: "от плана",
  progress_from_sales: "от продаж",
  // Bonus
  bonus_earned: "Заработано бонуса",
  bonus_for_period: "За {count} мес.",
  bonus_debt_label: "удержано за покупки",
  bonus_payout_label: "к выплате",
  bonus_how: "Как считается",
  bonus_total_kpi: "Итоговый KPI",
  bonus_avg_suffix: " (среднее)",
  bonus_prem_kpi: "в т.ч. премиальный KPI",
  bonus_pct: "Бонусный процент",
  bonus_dept_base: "Чистые продажи отдела",
  bonus_earned_label: "Заработано бонуса",
  bonus_debt_table: "Удержано за покупки",
  bonus_payout_table: "К выплате",
  bonus_by_month: "По месяцам",
  bonus_by_month_kpi: "KPI",
  bonus_by_month_avg_kpi: "средний KPI",
  bonus_by_month_bonus: "бонус",
  bonus_by_month_avg_bonus: "средний бонус",
  bonus_by_month_debt: "(долг −{value})",
  bonus_formula: "Бонус = чистые продажи отдела × ваш бонусный процент (зависит от итогового KPI). Это командная база с индивидуальным множителем — поэтому коллеги с тем же бонусным % получают такую же сумму.",
  // No data
  no_data_title: "За выбранный период данных нет",
  no_data_note: "Возможно, вы не работали в этом месяце или данные ещё не загружены.",
  // Errors
  err_loading: "Загрузка…",
  err_access_denied: "Доступ закрыт",
  err_access_admin_note: "Обратитесь к администратору.",
  admin_button:           "⚙ Админ",
  admin_close:            "Закрыть",
  admin_tab_access:       "Доступы",
  admin_tab_upload:       "Загрузка",
  access_list_title:      "Активные привязки",
  access_list_empty:      "Привязок пока нет",
  access_add_title:       "Привязать сотрудника",
  access_form_phone:      "Номер телефона (+380...)",
  access_form_manager:    "Менеджер",
  access_form_submit:     "+ Привязать",
  access_form_invalid:    "Неверный формат номера. Ожидается +380XXXXXXXXX",
  access_form_dup:        "Этот номер уже привязан. Сначала отвяжите.",
  access_revoke_confirm:  "Отвязать {phone}?",
  access_revoked_label:   "(отозван)",
  upload_title:           "Загрузить новый KPI.xlsx",
  upload_pick:            "Выбрать файл",
  upload_send:            "Загрузить",
  upload_in_progress:     "Загружаем…",
  upload_success:         "✅ Загружено. Месяцев: {months}, менеджеров: {managers}, строк: {rows}.",
  upload_warnings_title:  "Предупреждения парсера:",
  upload_history_title:   "Последние загрузки",
  upload_history_empty:   "Загрузок ещё не было",
  upload_history_warns:   "{n} предупреждений",
  upload_src_xlsx:        "xlsx",
  upload_src_panel:       "панель",
  upload_final:           "выплачено",
  upload_prelim:          "предварительно",
  upload_skipped:         "Пропущены месяцы панели: {months}",
  admin_tab_managers:       "Менеджеры",
  managers_list_title:      "Сотрудники",
  managers_add_title:       "Добавить нового",
  managers_form_id:         "ID (латиницей, без пробелов — например petrov)",
  managers_form_name:       "Полное имя (как в xlsx)",
  managers_form_submit:     "+ Добавить",
  managers_form_invalid_id: "ID может содержать только латинские буквы, цифры, _, - (макс 32)",
  managers_form_dup_id:     "ID уже занят",
  managers_form_dup_name:   "Менеджер с таким именем уже есть",
  managers_form_need_name:  "Введите полное имя",
  managers_archive:         "Архивировать",
  managers_restore:         "Восстановить",
  managers_archived_label:  "(в архиве)",
  managers_archive_confirm: "Архивировать {name}? Менеджер исчезнет из дропдауна и рейтинга, но история данных сохранится.",
  maintenance_title:    "Профилактические работы",
  maintenance_fallback: "Сервис временно недоступен, скоро вернёмся.",
  admin_tab_settings:           "Настройки",
  settings_maintenance_title:   "Профилактические работы",
  settings_maintenance_help:    "Когда включено: всем сотрудникам, кроме админа, показывается страница-заглушка с текстом ниже.",
  settings_maintenance_on:      "Включено",
  settings_maintenance_off:     "Выключено",
  settings_msg_ru:              "Сообщение (RU)",
  settings_msg_uk:              "Сообщение (UK)",
  settings_save:                "Сохранить",
  settings_saved:               "Сохранено",
  admin_tab_logs:               "Логи",
  logs_title:                   "Последние входы",
  logs_login_ok:                "Вход",
  logs_login_denied:            "Отказ",
  logs_unknown_user:            "Неизвестный",
  logs_empty:                   "Пока пусто",
  logs_refresh:                 "Обновить",
};

const UK: Dict = {
  // Tabs
  tab_stats: "Статистика",
  tab_rating: "Рейтинг",
  tab_progress: "Прогрес",
  tab_bonus: "Бонус",
  // Period selector
  period_month: "Місяць",
  period_quarter: "Квартал",
  period_half: "Півріччя",
  period_year: "Рік",
  coverage_all: "Враховані всі {expected} міс. періоду",
  coverage_partial: "Враховані {actual} із {expected} міс. — даних за решту поки немає",
  prelim_badge: "попередньо",
  prelim_updated: "попередньо · оновлено {at}",
  prelim_period: "попередньо: {months} · оновлено {at}",
  // Header
  header_dept: "Відділ",
  header_maintenance_on: "Профілактика увімкнена",
  header_maintenance_tap: "тап, щоб вимкнути",
  // Stats
  kpi_label: "Підсумковий KPI за період",
  kpi_status_over: "Перевиконання",
  kpi_status_norm: "В нормі",
  kpi_status_under: "Недобір",
  kpi_status_avg_suffix: " · в середньому за місяць періоду",
  card_pure_sales: "Чисті продажі (особисті)",
  card_returns: "Повернення",
  card_remarks: "Зауваження",
  card_reprimands: "Догани",
  card_competence: "Компетенції",
  card_dept: "Чисті продажі відділу",
  card_dept_note: "Рахується на всю команду, в індивідуальний рейтинг не входить",
  plan_label: "план {value}",
  norm_label: "норма ≤ {value}%",
  kpi_value: "KPI: {value}%",
  kpi_value_avg: "KPI: {value}% (середнє)",
  total_sales_note: "Всього продажів: {value} грн (з урахуванням повернень)",
  delivery_note: "у т. ч. вирахувано доставку, оплачену клієнтками: {value} грн",
  returns_amount_note: "Сума повернень: {value} грн",
  competence_score_note: "Базове нарахування",
  // Rating
  rating_sales: "💰 Чисті продажі",
  rating_sales_sub: "· в середньому за день",
  rating_returns: "↩ Повернення",
  rating_returns_sub: "· % від продажів, чим менше — тим вищий рейтинг",
  rating_sales_full: "В середньому за робочий день · більше — краще",
  rating_returns_full: "% від продажів · чим менше — тим вищий рейтинг",
  rating_you: "Ви",
  rating_place_of: "місце",
  rating_of: "з",
  rating_grn_per_day: "грн/день",
  rating_pct_of_sales: "% від продажів",
  rating_how: "ⓘ Як рахується рейтинг",
  rating_how_sales: "Продажі порівнюються за середньоденним показником — враховується, скільки днів ви відпрацювали.",
  rating_how_returns: "Повернення порівнюються в % від ваших продажів: хто менше працював, той менше продав і в абсолюті повернув менше — тому справедливе саме відсоткове порівняння.",
  rating_how_anon: "Імена та цифри колег не розкриваються.",
  // Progress
  progress_title: "Мій прогрес",
  progress_sub: "Чисті продажі за місяцями",
  progress_compare_to: "до {month}",
  progress_no_compare: "немає даних за попередній період",
  progress_plan_sales: "План продажів",
  progress_returns: "Повернення",
  progress_from_plan: "від плану",
  progress_from_sales: "від продажів",
  // Bonus
  bonus_earned: "Зароблено бонусу",
  bonus_for_period: "За {count} міс.",
  bonus_debt_label: "утримано за покупки",
  bonus_payout_label: "до виплати",
  bonus_how: "Як рахується",
  bonus_total_kpi: "Підсумковий KPI",
  bonus_avg_suffix: " (середнє)",
  bonus_prem_kpi: "у т.ч. преміальний KPI",
  bonus_pct: "Бонусний відсоток",
  bonus_dept_base: "Чисті продажі відділу",
  bonus_earned_label: "Зароблено бонусу",
  bonus_debt_table: "Утримано за покупки",
  bonus_payout_table: "До виплати",
  bonus_by_month: "За місяцями",
  bonus_by_month_kpi: "KPI",
  bonus_by_month_avg_kpi: "середній KPI",
  bonus_by_month_bonus: "бонус",
  bonus_by_month_avg_bonus: "середній бонус",
  bonus_by_month_debt: "(борг −{value})",
  bonus_formula: "Бонус = чисті продажі відділу × ваш бонусний відсоток (залежить від підсумкового KPI). Це командна база з індивідуальним множником — тому колеги з тим самим бонусним % отримують таку саму суму.",
  // No data
  no_data_title: "За обраний період даних немає",
  no_data_note: "Можливо, ви не працювали в цьому місяці або дані ще не завантажені.",
  // Errors
  err_loading: "Завантаження…",
  err_access_denied: "Доступ закрито",
  err_access_admin_note: "Зверніться до адміністратора.",
  admin_button:           "⚙ Адмін",
  admin_close:            "Закрити",
  admin_tab_access:       "Доступи",
  admin_tab_upload:       "Завантаження",
  access_list_title:      "Активні прив'язки",
  access_list_empty:      "Прив'язок ще немає",
  access_add_title:       "Прив'язати співробітника",
  access_form_phone:      "Номер телефону (+380...)",
  access_form_manager:    "Менеджер",
  access_form_submit:     "+ Прив'язати",
  access_form_invalid:    "Невірний формат номера. Очікується +380XXXXXXXXX",
  access_form_dup:        "Цей номер вже прив'язано. Спочатку відв'яжіть.",
  access_revoke_confirm:  "Відв'язати {phone}?",
  access_revoked_label:   "(відкликано)",
  upload_title:           "Завантажити новий KPI.xlsx",
  upload_pick:            "Обрати файл",
  upload_send:            "Завантажити",
  upload_in_progress:     "Завантажуємо…",
  upload_success:         "✅ Завантажено. Місяців: {months}, менеджерів: {managers}, рядків: {rows}.",
  upload_warnings_title:  "Попередження парсера:",
  upload_history_title:   "Останні завантаження",
  upload_history_empty:   "Завантажень ще не було",
  upload_src_xlsx:        "xlsx",
  upload_src_panel:       "панель",
  upload_final:           "виплачено",
  upload_prelim:          "попередньо",
  upload_skipped:         "Пропущено місяці панелі: {months}",
  upload_history_warns:   "{n} попереджень",
  admin_tab_managers:       "Менеджери",
  managers_list_title:      "Співробітники",
  managers_add_title:       "Додати нового",
  managers_form_id:         "ID (латиницею, без пробілів — наприклад petrov)",
  managers_form_name:       "Повне ім'я (як у xlsx)",
  managers_form_submit:     "+ Додати",
  managers_form_invalid_id: "ID може містити лише латинські літери, цифри, _, - (макс 32)",
  managers_form_dup_id:     "ID вже зайнятий",
  managers_form_dup_name:   "Менеджер з таким ім'ям вже є",
  managers_form_need_name:  "Введіть повне ім'я",
  managers_archive:         "Архівувати",
  managers_restore:         "Відновити",
  managers_archived_label:  "(в архіві)",
  managers_archive_confirm: "Архівувати {name}? Менеджер зникне з дропдауну та рейтингу, але історія даних збережеться.",
  maintenance_title:    "Профілактичні роботи",
  maintenance_fallback: "Сервіс тимчасово недоступний, скоро повернемося.",
  admin_tab_settings:           "Налаштування",
  settings_maintenance_title:   "Профілактичні роботи",
  settings_maintenance_help:    "Коли увімкнено: усім співробітникам, крім адміна, показується сторінка-заглушка з текстом нижче.",
  settings_maintenance_on:      "Увімкнено",
  settings_maintenance_off:     "Вимкнено",
  settings_msg_ru:              "Повідомлення (RU)",
  settings_msg_uk:              "Повідомлення (UK)",
  settings_save:                "Зберегти",
  settings_saved:               "Збережено",
  admin_tab_logs:               "Логи",
  logs_title:                   "Останні входи",
  logs_login_ok:                "Вхід",
  logs_login_denied:            "Відмова",
  logs_unknown_user:            "Невідомий",
  logs_empty:                   "Поки порожньо",
  logs_refresh:                 "Оновити",
};

export function t(key: string, lang: Lang = "ru", vars?: Record<string, string | number>): string {
  const dict = lang === "uk" ? UK : RU;
  let s = dict[key] ?? RU[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      s = s.replaceAll(`{${k}}`, String(v));
    }
  }
  return s;
}
